import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeBeta';
const args = {};

export class ModeBeta extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
